<template lang="pug">
    .chat-page
        iframe.chat-iframe(ref="rocketChatIframe" :src="`${rocketChatUrl}`" allow="camera;microphone")

        send-tip-modal(v-if="showSendTipModal" :user="sendTipToUser" @close="showSendTipModal = false")

</template>

<script>
import UserProductsService from '../services/user-products-service'

export default {
    name: 'chat-page',

    data() { return {
        rocketChatUrl: window.addiesaas.rocketchat.url,
        showSendTipModal: false,
    }},

    created() {
        const that = this

        window.addEventListener('message', function(e) {
            const { eventName, data } = e.data

            if (eventName === 'init-rocket-effect') {
                that.initRocketEffect()
            }

            if (eventName === 'click-send-tip') {
                that.sendTip(data.username)
            }

            if (eventName === 'click-pay-per-view') {
                that.payPerView(data.message)
            }

            if (eventName === 'new-message') {
                that.newMessage(data)
            }
        })
    },

    methods: {
        initRocketEffect() {
            this.$refs.rocketChatIframe.contentWindow.postMessage({
                externalCommand: 'init-rocket-effect',
                url: window.addiesaas.url,
                token: this.$store.getters.authToken,
            }, '*')
        },

        async sendTip(username) {
            const { data: { data: user } } = await axios.get(`/api/customer/user/username/${username}`)
            this.sendTipToUser = user
            this.showSendTipModal = true
        },

        async payPerView(message) {
            const { u: { username }, _id: messageId, ppv: { price } } = message

            const { data: { data: user } } = await axios.get(`/api/customer/user/username/${username}`)

            const product = await UserProductsService.firstOfType(user.id, 'rocket_chat_ppv')

            this.$store.dispatch('Shop/Orders/Cart/addCartItem', {
                id: `ppv_${messageId}_via_${product.id}`,
                type: 'rocket_chat_ppv',
                payload: {
                    product_id: product.id,
                    options: {
                        message_id: messageId,
                    },
                },
                attributes: {
                    product: product,
                },
                total: price,
            })

            this.$router.push({ name: 'shopping-cart-page' })
        },

        newMessage(data) {
            if (data.u.username == this.$store.getters.authUser.username) {
                axios.post(`/api/customer/content-monitoring/rocket-chat-message`, data)
            }
        }
    },
}
</script>

<style lang="scss">
.chat-page {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .chat-iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
}
</style>
